export default __webpack_public_path__ + "static/media/decor7.8e4c9704.webp";